import { FormGroup, InputGroup } from "@blueprintjs/core";
import type { ExtraFieldTypeText } from "@package/ui-gql/index-data-access";
import { get, set } from "lodash";
import { useMemo } from "react";
import { isConditionFalsey } from "../service-data-form-utils";
import type { ServiceDataFormFieldBaseProps } from "./ServiceDataFormFieldEmpty";

type ServiceDataFormFieldTextProps = ServiceDataFormFieldBaseProps & {
  field: ExtraFieldTypeText;
};

function ServiceDataFormFieldTextContent({
  data,
  field,
  onSourceChanged,
}: ServiceDataFormFieldTextProps) {
  const value = useMemo<string>(
    () => get(data, field.source) ?? field.defaultValue ?? "",
    [data, field.defaultValue, field.source],
  );
  const disabled = useMemo<boolean>(
    () =>
      !!field.disabled ||
      (!!field.condition && isConditionFalsey(field.condition, data)),
    [data, field.condition, field.disabled],
  );

  return (
    <FormGroup disabled={disabled} label={field.label}>
      <InputGroup
        disabled={disabled}
        value={value}
        onValueChange={(v) =>
          onSourceChanged((draft) => {
            set(draft, field.source, v);
          })
        }
      />
    </FormGroup>
  );
}

export function ServiceDataFormFieldText({
  field,
  onSourceChanged,
  data,
}: ServiceDataFormFieldBaseProps) {
  if (field.__typename === "ExtraFieldTypeText") {
    return (
      <ServiceDataFormFieldTextContent
        field={field}
        data={data}
        onSourceChanged={onSourceChanged}
      />
    );
  }

  return null;
}
